import axios from 'axios'
import { resolve } from 'core-js/fn/promise';
var protobuf = require("protobufjs");

const getDefaultState = () => {
    return {
        tests: {},
        probes: {},
        SPqueued: {},
        SPDaemon: {
            scSyncDaemonUp: false,
            scSyncDaemonNextPush: null,
        }
    }
  }


export const state = getDefaultState()

export const getters = {
    SPQueued(state) { return state.SPqueued; },
    tests(state) {
        if(!state.tests.length) return [];
        return state.tests.filter(e => e.testid.length > 0 && e.testid.length == 36 && e.testid.indexOf("-") > 0);
    },
    probes(state) { // TODO: order is wrong lower than 16 Elements
        if (state.probes === undefined)
        return;
        if(state.probes.length > 16) {
            var filtered = [];
            var chars = [ "A", "B", "C", "D", "E", "F", "G","H"];

            var index = 0;
            state.probes.forEach((p) => {
                index++;
                index = index < 10 ? "0"+index : index;
                chars.forEach((c) => {
                    var elements = state.probes.find(e => e.well.substring(0,1) == c && e.well.substring(1) == index);
                    if(elements) filtered.push(elements);
                })    
            })
            return filtered;
        }
        return state.probes;
    },
    getApoStats(state) {
        let total_probes = 0;
        let total_positive = 0;
        let total_invalids = 0;
        if(!state.tests.length) return false;
        state.tests.forEach((x) => {
            total_probes=total_probes+(x.probes);
            total_positive=total_positive+(x.probesPositive);
            total_invalids=total_invalids+(x.probesInvalid);
        })

        return {
            probes_total: total_probes,
            total_positive: total_positive,
            total_invalids: total_invalids,
        }
    },
    getSPDaemonState(state) {
        return state.SPDaemon;
    }
}

export const mutations = {
    setTests(state, tests) {
        state.tests = tests;
    },
    ClearaState(state) {
        Object.assign(state, getDefaultState())
    },
    SetProbes(state, probes) {
        state.probes = probes;
    },
    setProbeTransmitted(state, probe) {
        var p = state.probes.find(e => e.barcode == probe);
        if(p) {
            p.transfered = true;
        }
    },
    SetScreeningPortalQueued(state, queue) {
        state.SPqueued = queue;
    },
    SetScreeningPortalDaemonState(state, data) {
        state.SPDaemon = data;
    }    
}

export const actions = {
    LoadTest(state, testid) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/test/"+testid, { headers: { Authorization: 'Berear '+state.getters.accessToken}})
            .then((r) => {
                resolve(r.data);
            })
            .catch((err) => {
                alert("Error: "+err.message);
            })
        })
    },
    // GetScreeningPortalTransfered has been migrated to NodeJS server
    GetScreeningPortalTransfered(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/screeningportal/queue", { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                var root = protobuf.Root.fromJSON(require("/bundle.json"));
                var Probe = root.lookupType("ScreeningPortalProbeList");          
                var message = Probe.decode(Buffer.from(r.data));
                state.commit("SetScreeningPortalQueued", message.ScreeningPortalProbe);
            })

        })
    },
    sendScreeningPortal(state, data) {
        axios.post(process.env.VUE_APP_API_SERVER + "/screeningportal/connect", data, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then(() => {
        })
    },
    RefreshStates() {
        //this.commit("GetScreeningPortalDaemonState");
    },
    // GetScreeningPortalDaemonState(state) {
    //     axios.get(process.env.VUE_APP_API_SERVER + "/screeningportal/status", { headers: { Authorization: 'Berear '+state.getters.accessToken} })
    //     .then((r) => {
    //         state.commit("SetScreeningPortalDaemonState", r.data);
    //     })        
    // },
    SetScreeningPortalDelayToZero(state,probe) {
        axios.post(process.env.VUE_APP_API_SERVER + "/screeningportal/modify", { barcode: probe.barcode }, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then(() => {
            state.dispatch('GetScreeningPortalTransfered')
        })
    },
    CancelScreeningPortalTransmit(state, data) {
        axios.post(process.env.VUE_APP_API_SERVER + "/screeningportal/cancel", { barcode: data.barcode }, { headers: { Authorization: 'Berear '+state.getters.accessToken} })
        .then(() => {
            state.dispatch('GetScreeningPortalTransfered')
        })
    },
    LoadProbes(state, testid) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/test/"+testid+"/probe?format=json", { responseType: 'json', headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                state.commit("SetProbes", r.data.Probe);
                resolve(r.data.Probe);
            })
        })
    },
    ClearState(state) {
        state.commit("ClearaState")
    },
    LoadPieData(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            if(state.getters.getApoStats !== false) {
                resolve(true);
            }
        })
    },    
    LoadInitialData(state) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_SERVER + "/test", { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+state.getters.accessToken} })  // Bearear
            .then((r) => {
                var root = protobuf.Root.fromJSON(require("/bundle.json"));
                var Probe = root.lookupType("TestList");          
                var message = Probe.decode(Buffer.from(r.data));
                state.commit("setTests", message.Test);
                state.dispatch("GetScreeningPortalTransfered")
                //state.dispatch("GetScreeningPortalDaemonState");
            });            
        })
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }